import { FaberApi } from 'api'
import { AxiosPromise } from 'axios'
import { EsimReplacement, WhitelistLocations } from 'types/api/faber/subscription.type'

class ReplacementAPI {
  /**
   * @returns
   */
  static esimReplacement(body: {
    userId: string
    remarks: string
    faberToken: string
  }): AxiosPromise<EsimReplacement> {
    return FaberApi.httpPost(
      `/esim/replacement`,
      { Authorization: `Bearer ${body.faberToken}` },
      body
    )
  }

  static externalEsimReplacement(body: {
    userId: string
    remarks: string
    faberToken: string
  }): AxiosPromise<EsimReplacement> {
    return FaberApi.httpPost(
      `/sim/ext/esim/replacement`,
      { Authorization: `Bearer ${body.faberToken}` },
      body
    )
  }

  static esimReplacementUpdate(body: {
    userId: string
    newICCID: string
    faberToken: string
  }): AxiosPromise<EsimReplacement> {
    return FaberApi.httpPost(
      `/sim/ops/multiesim/update`,
      { Authorization: `Bearer ${body.faberToken}` },
      body
    )
  }

  static esimOTPReplacement(body: {
    userId: string
    remarks: string
    faberToken: string
    oldICCID?: string
  }): AxiosPromise<EsimReplacement> {
    return FaberApi.httpPost(
      `/sim/ops/esim/replace/onetimepack`,
      { Authorization: `Bearer ${body.faberToken}` },
      body
    )
  }

  static externalEsimOTPReplacement(body: {
    userId: string
    remarks: string
    faberToken: string
    oldICCID?: string
  }): AxiosPromise<EsimReplacement> {
    return FaberApi.httpPost(
      `/sim/ext/esim/replace/onetimepack`,
      { Authorization: `Bearer ${body.faberToken}` },
      body
    )
  }

  static getWhitelistLocations(
    faberToken: string
  ): AxiosPromise<WhitelistLocations> {
    return FaberApi.httpGet('/sim/ops/esim/whitelist/location', {
      Authorization: `Bearer ${faberToken}`
    })
  }

  static switchWhitelist(body: {
    faberToken: string
    apn: string
    imsi: string
    issue: string[]
    country: string
    iccids: string[]
    userId: string
  }) {
    return FaberApi.httpPost(
      `/sim/ops/esim/whitelist/switch`,
      { Authorization: `Bearer ${body.faberToken}` },
      body
    )
  }

  static externalSwitchWhitelist(body: {
    faberToken: string
    apn: string
    imsi: string
    issue: string[]
    country: string
    iccids: string[]
    userId: string
  }) {
    return FaberApi.httpPost(
      `/sim/ext/esim/whitelist/switch`,
      { Authorization: `Bearer ${body.faberToken}` },
      body
    )
  }
}

export default ReplacementAPI
